import { useState, useEffect, useContext } from 'react'
import { ClientContext } from '../../../contexts/clientProvider'
import { AnexosContext } from '../../../contexts/anexosProvider';
import { UserContext } from '../../../contexts/userProvider';
import DataTable from '../../Table';
import LoadingSpinner from '../../Loader/load'
import Visualizar from '../Visualizar';
import Linhas from '../Linhas';
import BaseSelect from '../../General/FormsComp/Select/BaseSelect';

const Consulta = () => {
    const { clientes, setAlert } = useContext(ClientContext);
    const { anexosByClient, deleteAnexo } = useContext(AnexosContext);
    const { isGerente } = useContext(UserContext);
    const [clients, setClients] = useState(null);
    const [anexos, setAnexos] = useState(null);
    const [anexoSelecionado, setAnexoSelecionado] = useState(null);
    const [type, setType] = useState('');
    const [loading, setLoading] = useState(false);
    const [clienteSelecionado, setClienteSelecionado] = useState(null);
    const components = {
        visualizar: (
            <Visualizar
                anexo={anexoSelecionado}
                setAnexo={setAnexoSelecionado}
                closeModal={closeModal}
                onUpdated={refreshAnexos}
            />
        ),
        linhas: <Linhas anexo={anexoSelecionado} closeModal={closeModal} />
    }

    useEffect(() => {
        let newClients = clientes ? clientes : [];
        setClients(newClients);
    }, [clientes]);

    async function handleSelectClient(e) {
        setLoading(true);
        setAnexos(null)
        const idCliente = e.target.value
        const anexos = await anexosByClient(idCliente)
        setAnexos(anexos)
        setClienteSelecionado(idCliente)
        setLoading(false);
    }

    async function refreshAnexos() {
        if (!clienteSelecionado) return;
        setLoading(true);
        const anexosAtualizados = await anexosByClient(clienteSelecionado)
        setAnexos(anexosAtualizados)
        setLoading(false);
    }

    const headers = [
        { label: "Anexo", key: "nome", sortable: true },
        { label: "Telefone", key: "telefone", sortable: false },
        { label: "Status", key: "status_local", sortable: false },
        {
            label: "Ações", key: "actions", sortable: false,
            actions: {
                visualizar: visualizarAnexo,
                linhas: visualizarLinhas,
                ...(isGerente ? { deletar: deleteAnexoById } : {}),
            }
        },
    ];

    function visualizarAnexo(id) {
        const newAnexo = anexos.find((anexo) => anexo.id === id);
        setAnexoSelecionado(newAnexo);
        setType('visualizar');
    }

    function deleteAnexoById(id) {
        if (!id) return console.error('ID não informado');
        setAlert({
            type: 'confirm',
            placeholder: 'Deseja realmente deletar o anexo?',
            visible: true,
            confirm: true,
            title: 'Atenção!',
            callback: () => deleteAnexo(id),
            params: id
        })
        const anexos = anexosByClient(clienteSelecionado)
        if (anexos) {
            setAnexos(anexos)
        }
    }

    function visualizarLinhas(id) {
        const newAnexo = anexos.find((anexo) => anexo.id === id);
        setAnexoSelecionado(newAnexo);
        setType('linhas');
    }

    function closeModal() {
        setAnexoSelecionado(null);
        setType('');
    }

    return (
        <div className='space-y-6'>
            <div className='max-w-md'>
                <BaseSelect
                    label="Cliente"
                    name="cliente"
                    value=""
                    onChange={handleSelectClient}
                    options={clients ? clients.slice().sort((a, b) => a.nome.localeCompare(b.nome)) : []}
                    placeholder="Selecione o cliente"
                    valueKey="id"
                    labelKey="nome"
                />
            </div>
            
            {loading && (
                <div className='flex justify-center py-8'>
                    <LoadingSpinner />
                </div>
            )}
            
            {!loading && !anexos && (
                <div className='bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700'>
                    <div className='text-center py-12'>
                        <div className='text-gray-400 dark:text-gray-500 text-6xl mb-4'>
                            📋
                        </div>
                        <h3 className='text-lg font-medium text-gray-900 dark:text-white mb-2'>
                            Selecione um cliente
                        </h3>
                        <p className='text-gray-500 dark:text-gray-400'>
                            Escolha um cliente na lista acima para visualizar seus anexos
                        </p>
                    </div>
                </div>
            )}
            
            {anexos && anexos.length > 0 && (
                <div className='bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700'>
                    <DataTable headers={headers} data={anexos} itemsPerPage={10} />
                </div>
            )}
            
            {anexos && anexos.length === 0 && (
                <div className='bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700'>
                    <div className='text-center py-12'>
                        <div className='text-gray-400 dark:text-gray-500 text-6xl mb-4'>
                            📄
                        </div>
                        <h3 className='text-lg font-medium text-gray-900 dark:text-white mb-2'>
                            Nenhum anexo encontrado
                        </h3>
                        <p className='text-gray-500 dark:text-gray-400'>
                            Este cliente não possui anexos cadastrados
                        </p>
                    </div>
                </div>
            )}
            
            {type && components[type]}
        </div>
    )
}

export default Consulta
